// extracted by mini-css-extract-plugin
export default {"button":"ApplyNow_button__uZCcw","p":"ApplyNow_p__6YJTD"};